import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HtmlTemplateDirective } from "./html-template.directive";
import { HtmlTemplateUtils, TemplateConfigurationOptionsDto } from "clearline-common";
import { CfsHtmlTemplateStyleType, HtmlTemplateParameters, TemplateLogoSourceType } from "clearline-api";
import { BehaviorSubject } from "rxjs";
import { CfsTemplateErrorTypes } from "../cfs-template-errors";
import { HtmlTemplateBaseComponent } from "./html-template-base-component";

@Component({
  selector: "lib-html-template",
  standalone: true,
  imports: [CommonModule, HtmlTemplateDirective],
  templateUrl: "./html-template.component.html",
  styleUrls: ["./html-template.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HtmlTemplateComponent extends HtmlTemplateBaseComponent implements OnInit {
  @Input() isPrintView = false;

  @Input() set configurationOptions(configOptions: TemplateConfigurationOptionsDto | null) {
    if (configOptions?.logo) {
      const { logo } = configOptions;
      this.isNoneLogoTemplate = logo?.sourceType === TemplateLogoSourceType.None;
    }
  }

  @Input() set parameters(parameters: HtmlTemplateParameters | null) {
    if (parameters) {
      this.styleType = parameters.styleType || CfsHtmlTemplateStyleType.Style1;

      this.isColumnMirrored = this.getIsColumnMirrored();
      this.isNoQrCodeStyle = HtmlTemplateUtils.isNoQrCodeStyle(this.styleType);
      this.isNoImageStyle = HtmlTemplateUtils.isNoImgStyle(this.styleType);
      this.isSwappedQrCodeImageStyle = HtmlTemplateUtils.isSwappedMediaStyle(this.styleType);
      this.isLargeImageStyle = this.largeImageStyles.includes(this.styleType);

      this.options$.next(parameters);
    } else {
      this.setError(CfsTemplateErrorTypes.EmptyData);
    }
  }

  protected readonly printBackgroundColor = "white";
  private readonly mirroredColumnStyles = [
    CfsHtmlTemplateStyleType.Style2,
    CfsHtmlTemplateStyleType.Style4,
    CfsHtmlTemplateStyleType.Style6,
    CfsHtmlTemplateStyleType.Style8
  ];
  private readonly largeImageStyles = [
    CfsHtmlTemplateStyleType.Style1,
    CfsHtmlTemplateStyleType.Style2,
    CfsHtmlTemplateStyleType.Style3,
    CfsHtmlTemplateStyleType.Style4
  ];

  protected styleType: CfsHtmlTemplateStyleType = CfsHtmlTemplateStyleType.Style1;
  protected options$ = new BehaviorSubject<HtmlTemplateParameters | null>(null);

  protected isColumnMirrored = false;
  protected isNoQrCodeStyle = false;
  protected isNoImageStyle = false;
  protected isSwappedQrCodeImageStyle = false;
  protected isLargeImageStyle = false;
  protected isNoneLogoTemplate = false;

  override ngOnInit(): void {
    super.ngOnInit();

    this.initContentLoadByStyle();
  }

  private initContentLoadByStyle(): void {
    if (this.isNoQrCodeStyle) {
      this.qrCodeLoaded$.next(true);
    }

    if (this.isNoImageStyle) {
      this.mainImageLoaded$.next(true);
    }

    if (this.isNoneLogoTemplate) {
      this.logoLoaded$.next(true);
    }
  }

  private getIsColumnMirrored(): boolean {
    return this.mirroredColumnStyles.includes(this.styleType);
  }
}
